import { Amount } from '../../../typings'
import { isCoverOnCreateFlowEnabled } from '../utils/features'
import serverData from '../utils/server-data'
import { groupApi } from './groupApi'

export interface UpdateGroupPayload {
  id: string
  name: string
  description: string
  targetAmount: Amount
  targetDate: string
  backgroundImageUrl?: string
}

export const updateGroupApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    updateGroup: builder.mutation<
      { formattedTargetDate: string },
      UpdateGroupPayload
    >({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        headers: { 'X-CSRF-Token': (serverData as any)._csrf },
        method: 'PUT',
        body,
      }),
      async onQueryStarted({ id, ...body }, { dispatch, queryFulfilled }) {
        const putResult = dispatch(
          groupApi.util.updateQueryData(
            'getGroupDetail',
            id,
            (groupToUpdate) => {
              groupToUpdate.customer.moneyPools.moneyPool.name = body.name
              groupToUpdate.customer.moneyPools.moneyPool.description =
                body.description
              groupToUpdate.customer.moneyPools.moneyPool.targetAmount =
                body.targetAmount

              if (isCoverOnCreateFlowEnabled()) {
                groupToUpdate.customer.moneyPools.moneyPool.backgroundImageUrl =
                  body.backgroundImageUrl
              }
            },
          ),
        )

        try {
          const result = await queryFulfilled

          dispatch(
            groupApi.util.updateQueryData(
              'getGroupDetail',
              id,
              (groupToUpdate) => {
                groupToUpdate.customer.moneyPools.moneyPool.formattedTargetDate =
                  result.data.formattedTargetDate
              },
            ),
          )
        } catch {
          putResult.undo()
        }
      },
      invalidatesTags: (_result, error, arg) =>
        error ? [] : [{ type: 'groupDetail', id: arg.id }],
    }),
  }),
})

export const { useUpdateGroupMutation } = updateGroupApiSlice
